import { render, staticRenderFns } from "./CesOrderCustomerForm.vue?vue&type=template&id=60da834c"
import script from "./CesOrderCustomerForm.vue?vue&type=script&lang=js"
export * from "./CesOrderCustomerForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports